import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './core/config/auth.config';
import { AuthStorageKey } from '@progressio/client-toolkit';
import { PermissionApiService } from './core/services/permission-api.service';
import { filter, firstValueFrom } from 'rxjs';

export function initAuth(oauthService: OAuthService) {
  const permissionApiService: PermissionApiService = inject(PermissionApiService);
  const destroyRef: DestroyRef = inject(DestroyRef);

  return async (): Promise<void> => {
    // Set storage to localStorage
    oauthService.setStorage(localStorage);

    // Configure OAuth service
    oauthService.configure(authConfig);

    // Setup automatic silent refresh
    oauthService.setupAutomaticSilentRefresh();

    try {
      // Load discovery document and try to login
      await oauthService.loadDiscoveryDocumentAndTryLogin({
        onTokenReceived: () => {
          const stored: string | null = localStorage.getItem(AuthStorageKey.RETURN_URL);
          if (stored) {
            localStorage.removeItem(AuthStorageKey.RETURN_URL);
            window.location.replace(stored);
          }
        },
        disableOAuth2StateCheck: false,
        disableNonceCheck: false,
      });

      if (oauthService.hasValidAccessToken()) {
        await firstValueFrom(permissionApiService.loadUserPermissions());
      }
    } catch (error: unknown) {
      console.error(error);
    }

    oauthService.events
      .pipe(
        filter((event: { type: string }) => event.type === 'token_received'),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe(() => {
        permissionApiService.loadUserPermissions().subscribe();
      });
  };
}
